import { MINUTES_PER_HOUR } from "~/kernel/dateTime/constants";
import type { ServicePricing } from "~/service/models/Service";

export function getStepPrice(
  pricing: Extract<ServicePricing, { type: "durationBased" }>,
) {
  return pricing.amount / (MINUTES_PER_HOUR / pricing.step);
}
